export const BRAND = {
  "clientId": "altoque2",
  "displayName": "altoque2",
  "legalName": "altoque2",
  "web": {
    "appTitle": "altoque2",
    "loginTitle": "Login",
    "apiBaseUrl": "https://api.juego5.altoque2.misrutas.info/api",
    "publicUrl": "https://juego5.altoque2.misrutas.info",
    "primaryColor": "#0A66E8",
    "secondaryColor": "#0F172A",
    "accentColor": "#16B857",
    "supportEmail": "soporte@altoque.com",
    "hideForbiddenActions": true,
    "showMenuIcons": false,
    "assetUrls": {
      "logoFull": "/brand/logo-full.svg",
      "logoMark": "/brand/logo-mark.svg",
      "favicon": "/favicon.ico",
      "appleTouchIcon": "/apple-touch-icon.png",
      "ogImage": "/og-image.png"
    }
  }
} as const;
